import styled from 'styled-components';

export const NumeroDocumento = styled.div`
	font-size: calc(1rem + ${props => props.theme.fontScale}%);
`;
